import VendorInfoContainer from "./VendorInfoContainer";
export default VendorInfoContainer;
